// extracted by mini-css-extract-plugin
module.exports = {"container":"_1shvwLN4yJ3gxRzMZsA3N9","list":"_2J3Ade_BxyfY16_yjzP-zy","item":"_2SPok12VMw7Zo3Kohipuan","dot":"_3DUvDsehkkYlFVLzFNf01O","input":"wLr1PJcsbPI2cIcgJJWzg"};